import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {CommonModal} from 'components/common';
import BookTable from './BookTable';
import BookCreation from './BookCreation';
import {fetchBooks, setCurrentBookPage, setCurrentBook, clearBooksAfterPage} from 'actions/books';

class BookList extends React.Component {
  static propTypes = {
    bookPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
      refreshTableKey: 0,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCreationSuccess = this.handleCreationSuccess.bind(this);
  }

  showModal() {
    this.setState({
      modalShown: true,
    });
  }

  closeModal() {
    this.setState({
      modalShown: false,
    });
  }

  handleCreationSuccess() {
    this.setState((prevState) => ({
      modalShown: false,
      refreshTableKey: prevState.refreshTableKey + 1,
    }));
  }

  render() {
    const {modalShown, refreshTableKey} = this.state;
    const {bookPages, fetchBooks, setCurrentBookPage, setCurrentBook, clearBooksAfterPage} = this.props;
    return (
      <div>
        <CommonModal title="Create New Book" onClose={this.closeModal} show={modalShown}>
          <BookCreation onSubmitSuccess={this.handleCreationSuccess} />
        </CommonModal>
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">Books</div>
              <Button variant="contained" color="primary" className="pull-right" onClick={this.showModal}>
                Create Book
              </Button>
            </h3>
            <BookTable
              {...{
                refreshTableKey,
                recordPages: bookPages,
                fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                  fetchBooks(q, page, perPage, sortOpts, {...extraFilters, summary: true}),
                setCurrentRecordPage: setCurrentBookPage,
                setCurrentRecord: setCurrentBook,
                clearRecordsAfterPage: clearBooksAfterPage,
              }}
            />
          </Panel>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bookPages: state.books.get('bookPages').toJS(),
});

const mapDispatchToProps = (dispatch) => ({
  fetchBooks: (...args) => dispatch(fetchBooks(...args)),
  setCurrentBookPage: (...args) => dispatch(setCurrentBookPage(...args)),
  setCurrentBook: (...args) => dispatch(setCurrentBook(...args)),
  clearBooksAfterPage: (...args) => dispatch(clearBooksAfterPage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookList);
